(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class ProductDescriptionClamp extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description-clamp__content');
      this.toggle = this.querySelector('.product-description-clamp__toggle');

      if (!this.content || !this.toggle) return;

      requestAnimationFrame(() => {
        if (this.content.scrollHeight <= this.content.clientHeight + 2) {
          this.toggle.hidden = true;
        }
      });

      this.toggle.addEventListener('click', () => {
        const expanded = this.hasAttribute('expanded');
        if (expanded) {
          this.removeAttribute('expanded');
          this.toggle.textContent = this.dataset.moreLabel;
        } else {
          this.setAttribute('expanded', '');
          this.toggle.textContent = this.dataset.lessLabel;
        }
      });
    }
  }

  if (!customElements.get('product-description-clamp')) {
    customElements.define('product-description-clamp', ProductDescriptionClamp);
  }
  } catch(e) { console.error(e); }
})();

})();
